module.exports = __webpack_public_path__ + "img/model_28_zh.9b67242b.jpg";